import { Switch, Row, Col, Typography } from "antd"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AuthContext } from "../../../../contexts/auth/AuthContext"
import useSettings from "../../../../hooks/useSettings"
import hasPermission from "../../../../utils/hasPermission"
import { MessageOutlined, ShoppingCartOutlined, AppstoreOutlined } from "@ant-design/icons"

const { Text } = Typography

export default function SwitchSettings() {
  const { t } = useTranslation()
  const [settings, setSettings] = useSettings()
  const { authState } = useContext(AuthContext)

  function changeNotification(
    type: "moneyChat" | "orderChat" | "order",
    val: boolean
  ) {
    setSettings({
      ...settings,
      notifications: {
        ...(settings?.notifications || { moneyChat: true, orderChat: true, order: true }),
        [type]: val,
      },
    })
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: 8 }}>
      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: "10px 14px",
          background: "#f8fafc",
          borderRadius: 8,
          border: "1px solid #e2e8f0",
        }}
      >
        <Col xs={18}>
          <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 8, color: "#1e293b" }}>
            <MessageOutlined style={{ color: "#2563eb" }} />
            <span>{t("notifMoneyChat")}</span>
          </div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 2 }}>
            Всплывающие сообщения и звуковое оповещение при новых сообщениях в чате
          </Text>
        </Col>
        <Col xs={6} style={{ textAlign: "right" }}>
          <Switch
            checked={settings?.notifications?.moneyChat ?? true}
            onChange={(val) => changeNotification("moneyChat", val)}
          />
        </Col>
      </Row>

      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: "10px 14px",
          background: "#f8fafc",
          borderRadius: 8,
          border: "1px solid #e2e8f0",
        }}
      >
        <Col xs={18}>
          <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 8, color: "#1e293b" }}>
            <MessageOutlined style={{ color: "#16a34a" }} />
            <span>{t("notifOrderChat")}</span>
          </div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 2 }}>
            Звук и всплывающие окна при сообщениях по заказам
          </Text>
        </Col>
        <Col xs={6} style={{ textAlign: "right" }}>
          <Switch
            checked={settings?.notifications?.orderChat ?? true}
            onChange={(val) => changeNotification("orderChat", val)}
          />
        </Col>
      </Row>

      {hasPermission(authState.user, "/orders") && (
        <Row
          align="middle"
          justify="space-between"
          style={{
            padding: "10px 14px",
            background: "#f8fafc",
            borderRadius: 8,
            border: "1px solid #e2e8f0",
          }}
        >
          <Col xs={18}>
            <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 8, color: "#1e293b" }}>
              <ShoppingCartOutlined style={{ color: "#fa8c16" }} />
              <span>{t("notifNewOrderSound")}</span>
            </div>
            <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 2 }}>
              Звуковой сигнал при поступлении нового заказа
            </Text>
          </Col>
          <Col xs={6} style={{ textAlign: "right" }}>
            <Switch
              checked={settings?.notifications?.order ?? true}
              onChange={(val) => changeNotification("order", val)}
            />
          </Col>
        </Row>
      )}

      <Row
        align="middle"
        justify="space-between"
        style={{
          padding: "10px 14px",
          background: "#f8fafc",
          borderRadius: 8,
          border: "1px solid #e2e8f0",
        }}
      >
        <Col xs={18}>
          <div style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 8, color: "#1e293b" }}>
            <AppstoreOutlined style={{ color: "#7c3aed" }} />
            <span>{t("toolbar") || t("mobileToolbarLbl")}</span>
          </div>
          <Text type="secondary" style={{ fontSize: "12px", display: "block", marginTop: 2 }}>
            Быстрая панель для мобильных устройств
          </Text>
        </Col>
        <Col xs={6} style={{ textAlign: "right" }}>
          <Switch
            checked={settings?.toolbar ?? false}
            onChange={(val) => setSettings({ ...settings, toolbar: val })}
          />
        </Col>
      </Row>
    </div>
  )
}
